module.exports = __webpack_public_path__ + "img/1464.ff49732e.gif";